import type { PayloadAction } from '@reduxjs/toolkit';
import { CATALOG_TYPE_UNCATEGORIZED } from '../../../utils/types/catalogTypes';
import { toggleSuggestions } from '../../actions/suggestion/toggleSuggestions';
import { selectCategoriesForPredictions } from '../../selectors/category/predictions';
import { setSource } from './index';
import { treeIdByCatalogIdSelector } from '../../selectors/tree/data';
import type { TreePanes } from './index';
import type { Catalog } from '../../../entities/Catalog';
import type { RootState } from '../..';
import { trackUIInteraction } from '../../../utils/analyticsEvents';

interface SetSourceAction {
  pane: TreePanes;
  source: Catalog;
}

interface ListenerApi {
  dispatch: (action: unknown) => unknown;
  getState: () => RootState;
}

export const paneSetSourceListenerOptions = {
  actionCreator: setSource,
  effect: (action: PayloadAction<SetSourceAction>, listenerApi: ListenerApi) => {
    const { dispatch, getState } = listenerApi;
    const {
      pane,
      source: { catalogId },
    } = action.payload;
    const state = getState();
    const tree = treeIdByCatalogIdSelector(state, CATALOG_TYPE_UNCATEGORIZED);
    if (tree) {
      const categories = selectCategoriesForPredictions(state);
      const showPredictions = !!categories.size;
      // @ts-expect-error - toggleSuggestions is an async thunk with dynamic typing
      dispatch(toggleSuggestions({ tree, showPredictions }));
    }

    trackUIInteraction('switched_catalog', { pane, catalogId });
  },
};
